import {loadVue} from './load_vue';

export default {
  load: loadVue,
  auth_required: false
}

